import * as $ from "jquery";
export var handleSubmitButton = function () {
    var btn = document.getElementById("b-submit");
    if (btn) {
        btn.addEventListener("click", function () {
            var _a;
            var btnSubmit = document.getElementById("b-form-submit");
            if (btnSubmit) {
                btn.setAttribute("disabled", "true");
                (_a = btn.getElementsByClassName('loading-ring')[0]) === null || _a === void 0 ? void 0 : _a.setAttribute("style", "display: display-block !important");
                btnSubmit.click();
            }
        });
    }
};
export var handleFocusOnError = function () {
    var formElem = document.querySelector("#far-login-form");
    if (formElem) {
        var input = $('.input-validation-error:first');
        if (input[0]) {
            input.focus();
        }
    }
};
export var formTracking = function () {
    $("#far-login-form").submit(function (e) {
        var _a;
        var formElem = document.querySelector("#far-login-form");
        e.preventDefault();
        var formData = new FormData(formElem);
        formData.append("Input.Button", "login");
        var submitButton = $(this).find("button");
        submitButton.prop('disabled', true);
        (_a = submitButton.find('.loading-ring')) === null || _a === void 0 ? void 0 : _a.show();
        $.ajax({
            url: formElem.action,
            type: "POST",
            data: formData,
            success: handleData,
            processData: false,
            contentType: false,
            error: function () { return submitButton.prop('disabled', false); }
        });
        function handleData(data) {
            var _a, _b;
            submitButton.prop('disabled', false);
            (_a = submitButton.find('.loading-ring')) === null || _a === void 0 ? void 0 : _a.hide();
            if (data.includes(";;;")) {
                var splitData = data.split(";;;");
                var form = document.querySelector('div[data-form-id="73023562-4d06-f011-bae2-000d3a686d65"] form');
                if (form) {
                    var email = form.querySelector("input");
                    email.setAttribute("value", splitData[1]);
                    (_b = form.querySelector("button")) === null || _b === void 0 ? void 0 : _b.click();
                }
                setTimeout(function () { window.location.replace(splitData[0]); }, 1000);
            }
            else {
                var newDoc = document.open("text/html", "replace");
                newDoc.write(data);
                newDoc.close();
            }
        }
    });
};
